import camelize from 'camelize';
import { baseCreateApi } from 'services';

import { SCORECARD_RULES } from 'constants/automationRules';

export const eventsApi = baseCreateApi.injectEndpoints({
  overrideExisting: true,
  endpoints: builder => ({
    getAvomaEvents: builder.query({
      query: () => ({
        url: '/api/v1/avoma_event/av_events/',
        method: 'GET'
      }),
      transformResponse: response => camelize(response)
    }),
    getAutomationRules: builder.query({
      queryFn: async ({ eventType }, api, extraOptions, baseQuery) => {
        // For scorecard rules, return hardcoded rules without API call
        if (eventType === 'meeting.scorecard') {
          return { data: camelize(SCORECARD_RULES) };
        }

        // For other event types, make API call
        const result = await baseQuery({
          url: `/api/v1/avoma_rule/av_rules/?event_type=${eventType}`,
          method: 'GET'
        });

        if (result.error) {
          return { error: result.error };
        }

        return { data: camelize(result.data) };
      }
    }),
    getAutomationActionGroups: builder.query({
      query: () => ({
        url: '/api/v1/avoma_action/av_action_groups/',
        method: 'GET'
      }),
      transformResponse: response => camelize(response)
    }),
    getAutomationActionRules: builder.query({
      query: ({ actionGroupUid }) => ({
        url: `/api/v1/avoma_action/av_action_rules/?action_group_uid=${actionGroupUid}`,
        method: 'GET'
      }),
      transformResponse: response => camelize(response)
    }),
    getDynamicOptions: builder.query({
      query: ({ url }) => ({
        url,
        method: 'GET'
      }),
      transformResponse: response => camelize(response),
      serializeQueryArgs: ({ url, name }) => `${url}?name=${name}`
    })
  })
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAvomaEventsQuery,
  useGetAutomationRulesQuery,
  useGetAutomationActionGroupsQuery,
  useGetAutomationActionRulesQuery,
  useGetDynamicOptionsQuery
} = eventsApi;
